import styled from 'styled-components';

export const StyledStickyContainer = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  background-color: rgb(0, 0, 0, 0.85);
  width: 100%;
  height: 96px;
  z-index: 10;

  &.top {
    top: 0;

    &.show {
      visibility: visible;
      transition: all 0.3s;
    }

    &.hide {
      visibility: hidden;
      transition: all 0.3s;
      transform: translateY(-100%);
    }
  }

  &.bottom {
    bottom: 0;

    &.show {
      visibility: visible;
      transition: all 0.3s;
    }

    &.hide {
      visibility: hidden;
      transition: all 0.3s;
      transform: translateY(100%);
    }
  }
`;
